import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconCheckCircle = ({
  width = 24,
  height = 24,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M16.7908 9.75055C17.0697 9.46447 17.0697 9.00064 16.7908 8.71456C16.5118 8.42848 16.0596 8.42848 15.7806 8.71456L10.8889 13.7315L8.21936 10.9937C7.94042 10.7076 7.48816 10.7076 7.20921 10.9937C6.93026 11.2797 6.93026 11.7436 7.20921 12.0296L10.3838 15.2854C10.5178 15.4228 10.6994 15.5 10.8889 15.5C11.0783 15.5 11.26 15.4228 11.394 15.2854L16.7908 9.75055Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconCheckCircle)
